import useSWR from "swr";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "contexts/auth";
import { OWNER_END_POINTS } from "@/constants/owner/endPoints";

type Category = {
  id: number;
  name: string;
};

type Crew = {
  id: number;
  name: string;
  company_name: string;
};

type FilterSummaryData = {
  categories: Category[];
  crews: Crew[];
};

const useFilterSummaryData = () => {
  const { token } = useContext(AuthContext);
  const fetchWithToken = (url: any, token: any) =>
    axios.get(url, token).then((res) => res.data);

  const { data, error, isLoading } = useSWR<FilterSummaryData>(
    [OWNER_END_POINTS.TASK.FILTER_SUMMARY, token],
    ([url, token]) => fetchWithToken(url, token)
  );

  return {
    filterSummaryData: data,
    filterSummaryIsLoading: isLoading,
    filterSummaryError: error
  };
};

export default useFilterSummaryData;
